export default __webpack_public_path__ + "static/media/BGPreview.e69ed876.webp";